export enum ApiTagType {
  Role = 'Role',
  AlpacaOrder = 'AlpacaOrder',
  RolePermission = 'RolePermission',
  WithdrawRequest = 'WithdrawRequest',
  UserFeeDeductionRequest = 'UserFeeDeductionRequest',
  JadwaTransfer = 'JadwaTransfer',
  SubscriberPortfolio = 'SubscriberPortfolio',
  UserIndexFund = 'UserIndexFund',
  DerayahOrder = 'DerayahOrder',
  NotificationTemplate = 'NotificationTemplate',
  NotificationTemplateHistory = 'NotificationTemplateHistory',
  UserGift = 'UserGift',
  AccountDeletionRequest = 'AccountDeletionRequest',
  AccountDeletionBlockers = 'AccountDeletionBlockers',
  TreasurySetup = 'TreasurySetup',
  TreasuryOnboarding = 'TreasuryOnboarding',
  TreasuryKycConfirmation = 'TreasuryKycConfirmation',
  TreasuryOwnerAgreement = 'TreasuryOwnerAgreement',
  TreasuryKyb = 'TreasuryKyb',
  TreasuryKybReadiness = 'TreasuryKybReadiness',
  TreasuryAlpacaOnboarding = 'TreasuryAlpacaOnboarding',
  TreasuryAnalysis = 'TreasuryAnalysis',
  TreasuryContribution = 'TreasuryContribution',
  TreasuryRedeemRule = 'TreasuryRedeemRule',
  TreasuryRedeemRun = 'TreasuryRedeemRun',
  TreasuryWithdrawRequest = 'TreasuryWithdrawRequest',
  PlanRules = 'PlanRules',
  PlanRulesHistory = 'PlanRulesHistory',
  BankLookup = 'BankLookup',
  AlpacaFee = 'AlpacaFee',
  AlpacaFeeReport = 'AlpacaFeeReport',
  AlpacaFeeShare = 'AlpacaFeeShare',
  UserDividend = 'UserDividend',
}
